import React, { useEffect, useState } from "react"
import {
    TabContent,
    TabPane,
    NavItem,
    NavLink,
    Card,
    CardBody,
    CardHeader,
    FormGroup,
    Input,
    Label,
    Row,
    Col,
    Button
} from "reactstrap"
import classnames from "classnames"
import CreditsTable from "../Components/CreditsTable"

import countries from "../constants/countries.json"

const apiUrl = "https://balance.idexo.io"

const Settings = () => {
    const [activeTab, setActiveTab] = useState("1")
    const [balanceData, setBalanceData] = useState(null)

    useEffect(() => {
        if (!localStorage.jwtToken) return
        fetch(apiUrl, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                token: localStorage.jwtToken
            },
            json: true
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.error) {
                    alert("Error: " + data.error)
                } else {
                    if (data.data && data.data.balance) {
                        setBalanceData(data.data)
                    }
                }
            })
            .catch((error) => {
                console.log(error)
            })
    }, [])

    return (
        <React.Fragment>
            <div className="content">
                <div className="account-settings">
                    <Card>
                        <CardHeader className="bg-transparent border-bottom">
                            <ul className="nav nav-tabs nav-tabs-custom card-header-tabs ms-auto" role="tablist">
                                
                                
                                <NavItem>
                                    <NavLink
                                        to="#"
                                        className={classnames({
                                            active: activeTab === "1"
                                        })}
                                        onClick={() => {
                                            setActiveTab("1")
                                        }}
                                    >
                                        Password
                                    </NavLink>
                                </NavItem>
                            </ul>
                        </CardHeader>
                        <CardBody>
                            <TabContent activeTab={activeTab}>
                                
                               
                                <TabPane className="show" tabId="1">
                                    <Row>
                                        <Col md={12} lg={8}>
                                            <FormGroup className="mb-3">
                                                <Label htmlFor="old-password" className="form-label">
                                                    Current Password
                                                </Label>
                                                <Input type="password" className="form-control" id="old-password" />
                                            </FormGroup>
                                        </Col>
                                        <Col md={12} lg={8}>
                                            <FormGroup className="mb-3">
                                                <Label htmlFor="new-password" className="form-label">
                                                    New Password
                                                </Label>
                                                <Input type="password" className="form-control" id="new-password" />
                                            </FormGroup>
                                        </Col>
                                        <Col md={12} lg={8}>
                                            <FormGroup className="mb-3">
                                                <Label htmlFor="confirm-password" className="form-label">
                                                    Confirm Password
                                                </Label>
                                                <Input type="password" className="form-control" id="confirm-password" />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Button color="primary" className="waves-effect" onClick={() => {}}>
                                        Reset Password
                                    </Button>
                                </TabPane>
                            </TabContent>
                        </CardBody>
                    </Card>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Settings
